import React, { Fragment } from 'react'
import { withRouter } from 'react-router-dom'
import { Alert, Button, Card, Col, Icon, Popconfirm, Row, Tabs, Tooltip } from 'antd'
import style from '../../../../components/Sales/style.css'
import { strVal } from '../../../../modules/Utils'
import { get, sumBy } from 'lodash'
import CustomSpin from '../../../../elements/CustomSpin'
import Status from '../../../../elements/Status'
import RefreshButton from '../../../../elements/Buttons/RefreshButton'
import PayrollClaimForm from '../../../../components/People/PayrollClaim/AddPayrollClaim/PayrollClaimForm'
import DocumentsCont from '../../../../components/Common/Documents/DocumentsCont'
import History from '../../../../components/Common/History'
import CustomBreadCrumb from '../../../../components/Common/CustomBreadCrumb'
import PayrollClaimsLines from '../../../../components/People/PayrollClaim/AddPayrollClaim/Lines/PayrollClaimsLines'
import PayrollClaimLineModal from '../../../../components/People/PayrollClaim/AddPayrollClaim/Lines/PayrollClaimLineModal'
import PayrollClaimCSVModal from '../../../../components/People/PayrollClaim/AddPayrollClaim/Lines/PayrollClaimCSVModal'
import Amount from '../../../../components/Common/Amount'

const { TabPane } = Tabs

AddPayrollClaim.propTypes = {}

function AddPayrollClaim (props) {
  const {
    type,
    submitting,
    updating,
    fetching,
    fetchingActions,
    submit,
    fetch,
    update,
    formRef,
    actions,
    payrollClaim,
    handleActions,
    onHold,
    isNew,
  } = props

  const isConfirmed = ['Confirmed'].includes(payrollClaim.status)
  const isUpdatable = actions.find(a => a.key === 'update')
  const Operations = ({ payrollClaim, ...rest }) => {
    let ops = actions
      .filter(a => a.key !== 'update')
      .map(a => (
        <span>
          <Popconfirm
            placement="left"
            title={`Are you sure to ${a.value}?`}
            onConfirm={() => handleActions(a.key)}
            okText="Yes"
            cancelText="No">
            <a>{a.value}</a>
          </Popconfirm>
        </span>
      ))

    payrollClaim.status === 'Confirmed' &&
    ops.push(
      <span>
          <Popconfirm
            placement="left"
            title={`Are you sure you want to Hold?`}
            onConfirm={onHold}
            okText="Yes"
            cancelText="No">
            <a>{payrollClaim.paymentStatus === 'New' ? 'Hold' : 'Unhold'}</a>
          </Popconfirm>
        </span>,
    )

    return (
      <div {...rest}>
        {ops.length > 0
          ? ops.reduce((prev, curr) => [prev, <span className="ant-divider"/>, curr])
          : []}
      </div>
    )
  }

  const SubmitButton = () => (
    <Button
      style={{ float: 'right', marginBottom: 10 }}
      icon={'form'}
      loading={updating || submitting}
      type="primary"
      onClick={type !== 'edit' ? submit : update}>
      {type === 'edit' ? 'Apply Changes' : 'Submit'}
    </Button>
  )
  return (
    <CustomSpin spinning={fetching || fetchingActions}>
      <Card>
        <Row className={style.pageHeader}>
          <CustomBreadCrumb
            items={[
              {
                link: null,
                text: 'People',
              },
              {
                link: '#/people/payrollClaims',
                text: 'PayrollClaim',
              },
              {
                link: null,
                text: type === 'new' ? 'New PayrollClaim' : payrollClaim.code,
              },
            ]}
          />
          {type === 'new' && <h2 className={style.title}>New PayrollClaim</h2>}
          {type === 'edit' && (
            <Fragment>
              <Col span={17}>
                <h3 className={style.title}>
                  <h2 className={'icon-text-header'}>
                    <Icon
                      type="barcode"
                      style={{
                        marginRight: '5px',
                        color: '#08c',
                      }}
                    />
                    <Tooltip title="PayrollClaim Code">{strVal(payrollClaim, 'code')}</Tooltip>
                  </h2>
                  <Status value={strVal(payrollClaim, 'status')}/>
                  <Operations
                    style={{ marginTop: '10px' }}
                    payrollClaim={payrollClaim}
                    status={strVal(payrollClaim, 'status')}
                  />
                </h3>
              </Col>
              <Col span={5}>
                <Amount
                  data={[
                    {
                      name: 'Amount',
                      amount: sumBy(payrollClaim.lines, 'amount'),
                    },
                  ]}
                  currency={payrollClaim.currency}
                />
              </Col>
              <RefreshButton onClick={fetch}/>
            </Fragment>
          )}
        </Row>
      </Card>
      <Card className={style.contentCard}>
        <Tabs
          defaultActiveKey={get(props, 'location.hash') || '#details'}
          onChange={key => props.history.push(key)}>
          <TabPane
            tab={
              <span>
                <Icon type="info-circle"/>
                Details
              </span>
            }
            key="#details">
            <PayrollClaimForm ref={formRef} {...props} />
            <Col span={14}>
              {isNew && (
                <Alert
                  message="You can't edit any record now. After you click on submit, it will create a draft salaries for each employee then you can edit individual salary if it has any error or any additional lines."
                  type="info"
                />
              )}
            </Col>
            <PayrollClaimLineModal {...props} />
            <PayrollClaimCSVModal {...props} />
            <PayrollClaimsLines {...props} />
            {(isUpdatable || isNew) && (
              <Row style={{ marginTop: 10 }}>
                <SubmitButton/>
              </Row>
            )}
          </TabPane>
          <TabPane
            disabled={type !== 'edit'}
            tab={
              <span>
                <Icon type="copy"/>
                History
              </span>
            }
            key="#history">
            <History isArray={true} loading={fetching} owner={payrollClaim}/>
          </TabPane>
          <TabPane
            disabled={type !== 'edit'}
            tab={
              <span>
                <Icon type="folder-open"/>
                Documents
              </span>
            }
            key="#docs">
            <DocumentsCont
              email={true}
              emailLabel={'Email with PayrollClaim'}
              owner={payrollClaim}
            />
          </TabPane>
        </Tabs>
      </Card>
    </CustomSpin>
  )
}

export default withRouter(AddPayrollClaim)
